import * as React from "react";
import { forwardRef } from "react";
const SvgExclamationMarkTriangleIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 18 18", style: {
  enableBackground: "new 0 0 18 18"
}, xmlSpace: "preserve", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9,2.3L0,18h9h9L9,2.3z M10,16.9H8.1v-1.3H10V16.9z M8,14V8h2v6H8z" }));
const ForwardRef = forwardRef(SvgExclamationMarkTriangleIcon);
export { ForwardRef as ReactComponent };
